import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';
import { environment } from '../../../environments/environment';
import { ProductRecipe, ProductRecipeSearchCommand } from '../../models/item/product-recipe';

@Injectable({
  providedIn: 'root',
})
export class ProductRecipeProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.proxyUrls.itemApi}/api/v1/product-recipe`;

  getById(id: string): Observable<ApiResponse<ProductRecipe>> {
    return this.httpClient.get<ApiResponse<ProductRecipe>>(`${this.baseUrl}/${id}`);
  }

  getByOutputItemCode(itemCode: string): Observable<ApiResponse<ProductRecipe[]>> {
    return this.httpClient.get<ApiResponse<ProductRecipe[]>>(`${this.baseUrl}/by-output/${encodeURIComponent(itemCode)}`);
  }

  getByNumber(number: string): Observable<ApiResponse<ProductRecipe>> {
    return this.httpClient.get<ApiResponse<ProductRecipe>>(`${this.baseUrl}/number/${encodeURIComponent(number)}`);
  }

  getByNumbers(numbers: string[]): Observable<ApiResponse<ProductRecipe[]>> {
    return this.httpClient.post<ApiResponse<ProductRecipe[]>>(`${this.baseUrl}/number/batch`, numbers);
  }

  search(
    command: ProductRecipeSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
    matchAny = false,
  ): Observable<ApiResponse<PaginatedApiResponse<ProductRecipe>>> {
    let params = new HttpParams().set('pageNumber', pageNumber.toString()).set('pageSize', pageSize.toString());
    if (sortField) {
      params = params.set('sortField', sortField).set('sortOrder', sortOrder.toString());
    }
    if (matchAny) {
      params = params.set('matchAny', 'true');
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ProductRecipe>>>(`${this.baseUrl}/search`, command, { params });
  }
}
